import React from 'react';

export interface SectionTab {
  id: string;
  label: string;
}

interface SectionTabsProps {
  tabs: SectionTab[];
  activeTab: string;
  onTabChange: (id: string) => void;
}

/**
 * SectionTabs - premium pill/segmented control for section navigation.
 */
const SectionTabs: React.FC<SectionTabsProps> = ({ tabs, activeTab, onTabChange }) => {
  return (
    <div className="mb-7">
      <nav
        className="bg-white/70 border border-monday-border-light shadow-xs rounded-full p-1 inline-flex gap-1 overflow-x-auto mobile-scrollbar"
        aria-label="Section tabs"
      >
        {tabs.map((tab) => {
          const isActive = tab.id === activeTab;
          return (
            <button
              key={tab.id}
              type="button"
              onClick={() => onTabChange(tab.id)}
              className={[
                'whitespace-nowrap px-4 py-2 text-sm font-semibold rounded-full transition-all duration-200 ease-in-out',
                isActive
                  ? 'bg-primary-500 text-white shadow-primary'
                  : 'bg-transparent text-monday-text-muted hover:text-monday-text hover:bg-monday-header',
              ].join(' ')}
              aria-current={isActive ? 'page' : undefined}
            >
              {tab.label}
            </button>
          );
        })}
      </nav>
    </div>
  );
};

export default SectionTabs;
